<template>
  <div>
    <ClientOnly>
      <SFTooltipInfo
        v-if="!isLoggedIn"
        :title="$t('tooltip.my_account.title')"
        :description="$t('tooltip.my_account.description')"
      />
      <div
        v-else
        class="flex min-w-[180px] flex-col gap-3 rounded-[4px] bg-white p-4"
      >
        <SFLink :to="getLocalizedRoute(routeList.account)" raw>
          <div
            class="flex cursor-pointer items-center text-gray-700 hover:text-orange-500"
          >
            <div class="mr-3 flex size-4 items-center justify-center">
              <IconUser class="size-4" />
            </div>
            <span class="font-rubik text-md font-normal">
              {{ $t('tooltip.my_account.title') }}
            </span>
          </div>
        </SFLink>

        <div
          class="flex cursor-pointer items-center text-gray-700 hover:text-orange-500"
          @click="handleLogout"
        >
          <div class="mr-3 flex size-4 items-center justify-center">
            <IconLogoutRound class="size-4" />
          </div>
          <span class="font-rubik text-md font-normal">
            {{ $t('account_tabs.logout') }}
          </span>
        </div>
      </div>
    </ClientOnly>
  </div>
</template>

<script setup lang="ts">
import { ClientOnly } from '#components'
import SFTooltipInfo from '~/components/ui/SFTooltipInfo.vue'
import { SFLink } from '#storefront-ui/components'
import { useAuthentication, useRouteHelpers } from '~/composables'
import { routeList } from '~/utils/route'

const { isLoggedIn = false } = defineProps<{
  isLoggedIn?: boolean
}>()

const { getLocalizedRoute } = useRouteHelpers()

const { logout } = useAuthentication('logout')

const handleLogout = async () => {
  await logout()
}

defineOptions({
  name: 'SFHeaderUserAcount',
})
</script>
